import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { Link } from "react-router-dom";
import {isMobileOnly} from 'react-device-detect';

const HpPopupBlock = styled.div`
    display: ${props => props.display};
    //width : 295px;
    //height : 327px;
`;

const HpPopupImgContainerBlock = styled.p`
    width : ${isMobileOnly?"40vw":"295px"};
    height : ${isMobileOnly?"40vw":"295px"};
    overflow: hidden;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.3);
`;

const HpPopupImgBlock = styled.img`
    min-width: 100%; 
    min-height: 100%;
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
`;

const HpPopupBottomBlock = styled.div`
    padding : 8px 10px 8px 10px;
    background-color: rgba(0, 0, 0, 0.03);
    height : 32px;
`;

const HpPopupCheckBtnInputBlock = styled.input`
    display: inline-block;
    cursor: pointer;
    right: 5px;
    width: 16px;
    height: 16px;
    //border: 1px solid #999;
    margin : 0px;
    float: left;
    background-color: #fff;


    background-image: url(${props => props.checked ? '/assets/images/icon/checkbox_check.svg' : '/assets/images/icon/checkbox.svg'});

    &:focus{
        outline: none !important;
    }
`;

const HpPopupSpanBlock = styled.span`
    display: inline-block;
    line-height: 12px;
    color: #999;
    font-size: 12px; 
    float: left;
    margin-left : 10px;
    margin-top: 2px;    
`;

const HpPopupButtonContainerBlock = styled.p`
    width: 16px;
    height: 16px;
    float: right;
    cursor: pointer;
`;
const HpPopupButtonBlock = styled.button`
    vertical-align: top;
    margin-top: 3px;
    width: 10px;
    height: 10px;  
    background: url(/assets/images/icon/popup_close.png) center center/cover no-repeat;
`;

/* const BrandHomeStickyHeaderFirstBlock = styled.div`
    display: block;
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    height: 50px;
    padding: 18px 0;
    background-color: #ffc742;
    z-index: 10;
`; */


const HpPopup = ({ img, link, handlePopupClose, index }) => {
    const [checked, setChecked] = useState(false);


    const handleOnCloseBtn = () => {
        // console.log("handleOnCloseBtn")

        handlePopupClose(index, checked);

    }

    const handleOnClickImg = () => {
        // console.log("handleOnClickImg")

    }

    return (
        <HpPopupBlock>
            <HpPopupImgContainerBlock onClick={handleOnClickImg}>
                {/* <Link to="/event/openBeta1.html" target="_blank"> */}
                <Link to={link}>
                    <HpPopupImgBlock src={img} />
                </Link>
            </HpPopupImgContainerBlock>
            <HpPopupBottomBlock>
                <HpPopupCheckBtnInputBlock
                    type="checkbox"
                    checked={checked}
                    onChange={() => setChecked(!checked)} className="popchecked" />
                <HpPopupSpanBlock>
                    오늘은 그만보기
                </HpPopupSpanBlock>
                <HpPopupButtonContainerBlock onClick={handleOnCloseBtn}>
                    <HpPopupButtonBlock />
                </HpPopupButtonContainerBlock>
            </HpPopupBottomBlock>


        </HpPopupBlock>
    );
};

export default HpPopup;
